/* View list - grid */
jQuery(document).ready(function($) {

    var buttonTypeView = $('.type-view a');
    var buttonViewGrid = $('.type-view .type-view__grid');
    var buttonViewList = $('.type-view .type-view__list');
    var horsesList = $('.horses-list');

    //if has class .type-view__list -> addClass('active') to buttonViewList / removeClass('active') to buttonViewGrid && addClass('view-list') to horsesList

    //if has class .type-view__grid -> addClass('active') to buttonViewGrid / removeClass('active') to buttonViewList && addClass('view-grid') to horsesList

    buttonTypeView.click(function(e) {
        var $this = $(this);
        e.preventDefault();
        console.log($this);
        if( $this.hasClass('type-view__list') ){
            $this.addClass('active');
            buttonViewGrid.removeClass('active');
            horsesList.removeClass('view-grid').addClass('view-list');
            //and disable button ?
        } else if( $this.hasClass('type-view__grid')){
            $this.addClass('active');
            buttonViewList.removeClass('active');
            horsesList.removeClass('view-list').addClass('view-grid');
            //and disable button ?
        }
    })
});
